import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { MachineGroupsResponse } from "@src/types/namespace-configuration";

export interface GetMachineGroupsResult {
  success: boolean;
  data?: MachineGroupsResponse;
  error?: string;
}

export const getMachineGroupsUseCase =
  async (): Promise<GetMachineGroupsResult> => {
    try {
      const namespace =
        store.getState().yourSlice.authContext.customerNamespace;
      const machineGroups = await apiUseCases.getMachineGroups(namespace);

      return {
        success: true,
        data: machineGroups,
      };
    } catch (error) {
      return {
        success: false,
        error: parseAxiosApiError(error, "Failed to fetch machine groups")
          .message,
      };
    }
  };
